import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

interface ExpandedHousingTypesProps {
  housingTypes: string[];
}

const useStyles = makeStyles(() => ({
  housingTypes: {
    fontSize: 12,
    "& + &": {
      marginTop: 10,
    },
  },
}));

export const ExpandedHousingTypes: FC<ExpandedHousingTypesProps> = ({
  housingTypes,
}) => {
  const classes = useStyles();

  return (
    <div>
      {housingTypes.map((recDoc) => (
        <div key={recDoc} className={classes.housingTypes}>
          {recDoc}
        </div>
      ))}
    </div>
  );
};
